<template>
  <div>
    <div class="admin-list" v-for="(hirer, index) in hirers" :key="index">
      <row-card class="jobseeker-card user-card no-rb"
          :imageUrl="imageUrl(hirer)"
          :leftTitle="name(hirer)"
          :leftSubtitle="hirer.email"
          :rightTitle="company(hirer)"
          :rightSubtitle="null"
          @click="click(hirer.id)">
      </row-card>
    </div>
  </div>
</template>

<script>
import RowCard from '@/components/general/row-card'

export default {
  components: {RowCard},
  props: {
    hirers: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  methods: {
    click (id) {
      this.$emit('click', id)
    },
    imageUrl (user) {
      return user.profilePictureUrl || `/api/identicons/${user.id}`
    },
    name (user) {
      const firstName = user.firstName || ''
      const lastName = user.lastName || ''
      return `${firstName} ${lastName}`
    },
    locations (user) {
      return user.location || ''
    },
    role (user) {
      return user.role || 'Hirer'
    },
    company (user) {
      return user.companies.length > 0 ? user.companies.map(company => company.name).join(', ') : ''
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/admin/hirer/hirer-list.vue